export default "__VITE_ASSET__CiJKSzvv__"